import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TenantService } from '@vsolv/core/multi-tenant/web';
import { PortalService } from '@vsolv/packages/portal-config/web';
import { Warranty } from '@wsphere/warranties/domain';
import { shareReplay } from 'rxjs';
import { TenantFeature } from '../../../warranty/config/tenant-features.config';
import { TenantFeatureService } from '../../../warranty/services/tenant-feature.service';
import { CHECKOUT_CONFIG } from '../../config/checkout.config';
import { ProvisioningSessionService } from '../../services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-provision-warranty-complete',
  templateUrl: './admin-provision-warranty-complete.component.html',
  standalone: false,
})
export class AdminProvisionWarrantyCompleteComponent implements OnInit {
  constructor(
    private router: Router,
    private sessionSvc: ProvisioningSessionService,
    private tenantFeatureSvc: TenantFeatureService,
    private portalSvc: PortalService,
    private sanitizer: DomSanitizer,
    private tenantSvc: TenantService,
    private cdr: ChangeDetectorRef
  ) {}
  @Input() warranty?: Warranty.Model;
  @Input() staffView = false;

  @Output() dialogClose = new EventEmitter();

  canShowDeclaration$ = this.tenantFeatureSvc
    .isFeatureEnabled(TenantFeature.DECLARATION_PAGE)
    .pipe(shareReplay({ bufferSize: 1, refCount: true }));

  readonly checkoutConfig = CHECKOUT_CONFIG;

  checkoutConfirmationText: string | null | undefined;
  sanitizedCheckoutConfirmationText: SafeHtml = '';

  async ngOnInit() {
    const tenantId = this.tenantSvc.tenantId;
    if (tenantId) {
      const config = await this.portalSvc.getOne(tenantId);

      this.checkoutConfirmationText = config?.checkoutConfirmationText;

      // Sanitize once after fetch instead of in a getter
      this.sanitizedCheckoutConfirmationText = this.sanitizer.bypassSecurityTrustHtml(
        this.checkoutConfirmationText || ''
      );

      // Explicitly trigger change detection to ensure template updates
      this.cdr.detectChanges();
    }
  }

  closeDialog() {
    this.sessionSvc.close$.next();
    this.sessionSvc.sessionComplete$.next(false);
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
      this.sessionSvc.sessionComplete$.next(false);
    });
  }

  async goToWarranty(warranty: Warranty.Model, staffView: boolean) {
    if (!warranty) return;
    if (staffView) await this.router.navigate([`warranty/${warranty.id}`]);
    else
      await this.router.navigate([`warranty/${warranty.contractNumber}`]).then(() => {
        window.location.reload();
      });
    this.closeDialog();
  }
}
